var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeightIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8333 16.48H3.16667C3.075 16.48 3 16.552 3 16.64V17.84C3 17.928 3.075 18 3.16667 18H16.8333C16.925 18 17 17.928 17 17.84V16.64C17 16.552 16.925 16.48 16.8333 16.48ZM16.8333 2H3.16667C3.075 2 3 2.072 3 2.16V3.36C3 3.448 3.075 3.52 3.16667 3.52H16.8333C16.925 3.52 17 3.448 17 3.36V2.16C17 2.072 16.925 2 16.8333 2ZM12.0583 7.32C12.1833 7.32 12.2542 7.18 12.1771 7.086L10.0771 4.534C10.0632 4.51673 10.0453 4.50275 10.0249 4.49313C10.0045 4.48351 9.98211 4.47851 9.95937 4.47851C9.93664 4.47851 9.91421 4.48351 9.89381 4.49313C9.8734 4.50275 9.85557 4.51673 9.84167 4.534L7.74167 7.086C7.72417 7.10735 7.71329 7.133 7.71028 7.16002C7.70727 7.18703 7.71225 7.21431 7.72464 7.23873C7.73704 7.26315 7.75635 7.28373 7.78036 7.2981C7.80437 7.31248 7.83212 7.32007 7.86042 7.32H9.25V12.68H7.94167C7.81667 12.68 7.74583 12.82 7.82292 12.914L9.92292 15.464C9.98333 15.538 10.1 15.538 10.1583 15.464L12.2583 12.914C12.3354 12.82 12.2667 12.68 12.1396 12.68H10.75V7.32H12.0583Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeightIcon);
export default __webpack_public_path__ + "static/media/height-icon.6137a9595f4bb38bb2d2569b70e3058e.svg";
export { ForwardRef as ReactComponent };